import { useState } from 'react';
import {
  StyledCopyIconButton,
  StyledDoneIcon,
  StyledContentCopyIcon,
} from './styled';

type Props = {
  apiKey: string;
  onError?: (msg: string) => void;
};

const CopyTokenButton = ({ apiKey, onError }: Props) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = () => {
    if (apiKey) {
      navigator.clipboard
        .writeText(apiKey)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000);
        })
        .catch((err) => {
          onError?.(err);
        });
    }
  };

  return (
    <StyledCopyIconButton onClick={handleCopyClick} disabled={isCopied}>
      {isCopied ? <StyledDoneIcon /> : <StyledContentCopyIcon />}
    </StyledCopyIconButton>
  );
};

export default CopyTokenButton;
